<div class="row">
    <div class="col-12 col-md-4 mb-3">
        <div class=" text-center  ">
            <form #addForm="ngForm" (ngSubmit)="setData(addForm.value)" >
            <div class="ag-bg-red  d-flex justify-content-center" style="height: 3rem; border-radius: 10px 10px 0px 0px;">
                <h6 class="text-white align-self-center">Mon profil</h6>
            </div>
            <div class="p-1" style="height: 75vh; overflow-y: scroll; " *ngIf="data">
                <div class="text-center mb-3 p-5">
                    <img [src]="fileSrc"  height="200" width="150" class="img-thumbnail" alt="..." style="border-radius:50% 50% ;">
                  </div>
                  <div class="text-center form-group mb-3">
                    <label for="">Charger l'image</label>
                    <input type="file" accept='image/*' (change)="loadImg($event)" class="form-control" />
                </div>
                  <div class="p-1">
                    <div class="form-group">
                        <label for="">Email</label>
                        <input type="email" name="email" [(ngModel)]="data!.email" class="form-control">
                    </div>
                     <div class="form-group">
                        <label for="">Téléphone</label>
                        <input type="text" name="phone"  [(ngModel)]="data!.professor.phone" class="form-control">
                    </div>
                    <div class="d-flex justify-content-between">
                        <div class="">
                            <button type="reset" class="btn btn-sm btn-outline-dark" [disabled]="loading">Annuler</button>
                        </div>
                        <div class="">
                            <button type="submit" class="btn btn-sm text-white g-bg-danger" [disabled]="addForm.invalid || loading">Modifier <app-loading [isVisible]="loading"></app-loading></button>
                        </div>
                    </div>
                  </div>
                
            </div>
            </form>
        </div>
    </div>
    <div class="col-12 col-md-4 mb-3">
        <div class=" text-center  ">
            <div class="ag-bg-red  d-flex justify-content-center" style="height: 3rem; border-radius: 10px 10px 0px 0px;">
                <h6 class="text-white align-self-center">Sécurité du compte</h6>
            </div>
            <div class="p-1" style="height: 75vh; overflow-y: scroll; ">
                <div class="d-flex justify-content-between p-1">
                    <span><strong>Activer l'authentification à double facteur</strong></span>
                    <span><input type="checkbox" (change)="setSetting()" name="need_tfa" [value]="userSetting.need_tfa" [(ngModel)]="userSetting.need_tfa" [checked]="userSetting.need_tfa"></span>
                </div>
                <hr>
                <h6 class="text-center">Changer mon mot de passe</h6>
                <form class="" #mpForm="ngForm" (ngSubmit)="changePassword(mpForm.value)">
                    <div class="position-relative form-group">
                    <label for="exampleEmail" class="">Ancien mot de passe</label>
                    <input name="old_password" id="exampleEmail1" placeholder="Ancien mot de passe" type="password" class="form-control" required ngModel>
                    </div>
                    <div class="position-relative form-group">
                        <label for="exampleEmail" class="">Nouveau mot de passe</label>
                        <input name="new_password" id="exampleEmail2" placeholder="Nouveau mot de passe" type="password" class="form-control" required ngModel>
                        </div>
                        <div class="position-relative form-group">
                            <label for="exampleEmail" class="">Confirmer moot de passe</label>
                            <input name="confirm_password" id="exampleEmail3" placeholder="Confirmer mot de passe" type="password" class="form-control" required ngModel>
                            </div>
             
              
                
                    <button class="mt-1 btn btn-success" [disabled]="mpForm.invalid || loading" type="submit">Changer le mot de passe  <app-loading [isVisible]="loading"></app-loading></button>
            </form>
            </div>
        </div>
    </div>
    <div class="col-12 col-md-4 mb-3">
        <div class=" text-center  ">
            <div class="ag-bg-red  d-flex justify-content-center" style="height: 3rem; border-radius: 10px 10px 0px 0px;">
                <h6 class="text-white align-self-center">Préférence</h6>
            </div>
            <div class="p-1" style="height: 75vh; overflow-y: scroll; ">
                <div class="d-flex justify-content-between p-1">
                    <span><strong>Recevoir les notifications</strong></span>
                    <span>
                        <ui-switch (change)="setSetting()" name="need_notification"  [(ngModel)]="userSetting.need_notification"></ui-switch>
                    </span>
                </div>
                <ng-container class="ps-3" *ngIf="userSetting.need_notification" >
                    <div class="d-flex justify-content-between p-1">
                        <span><strong>Evaluation planifiée</strong></span>
                        <span><input type="checkbox" (change)="setSetting()" name="mark_alert" [value]="userSetting.mark_alert" [(ngModel)]="userSetting.mark_alert" [checked]="userSetting.mark_alert"></span>
                    </div>
                    <hr>
                    <div class="d-flex justify-content-between p-1">
                        <span><strong>Informations utiles</strong></span>
                        <span><input type="checkbox" (change)="setSetting()" name="useful_alert" [value]="userSetting.useful_alert" [(ngModel)]="userSetting.useful_alert" [checked]="userSetting.useful_alert"></span>
                    </div>
                    <hr>
                    <div class="d-flex justify-content-between p-1">
                        <span><strong>Agenda</strong></span>
                        <span><input type="checkbox" (change)="setSetting()" name="agenda_alert" [value]="userSetting.agenda_alert" [(ngModel)]="userSetting.agenda_alert" [checked]="userSetting.agenda_alert"></span>
                    </div>
                    <hr>
                    <div class="d-flex justify-content-between p-1">
                        <span><strong>Rappels</strong></span>
                        <span><input type="checkbox" (change)="setSetting()" name="reminder_alert" [value]="userSetting.reminder_alert" [(ngModel)]="userSetting.reminder_alert" [checked]="userSetting.reminder_alert"></span>
                    </div>
                    <hr>
                    <div class="d-flex justify-content-between p-1">
                        <span><strong>Programme de cours</strong></span>
                        <span><input type="checkbox" (change)="setSetting()" name="timetable_alert" [value]="userSetting.timetable_alert" [(ngModel)]="userSetting.timetable_alert" [checked]="userSetting.timetable_alert"></span>
                    </div>
                    <hr>
                </ng-container>
                
      
            </div>
        </div>
    </div>
</div>